import {
    // FILE_UPLOAD,
    CREATE_ADMIN_SOCIAL_CARE_NAVIGATOR,
    RETRIEVE_ADMIN_SOCIAL_CARE_NAVIGATOR,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_SOCIAL_CARE_NAVIGATOR,
    UPDATE_ADMIN_SOCIAL_CARE_NAVIGATOR,
    DELETE_ADMIN_SOCIAL_CARE_NAVIGATOR,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminSocialCareNavigator from "../service/AdminSocialCareNavigator";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminSocialCareNavigator.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminSocialCareNavigator.create(data);
        dispatch({
            type: CREATE_ADMIN_SOCIAL_CARE_NAVIGATOR,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminSocialCareNavigator.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_SOCIAL_CARE_NAVIGATOR,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminSocialCareNavigator.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_SOCIAL_CARE_NAVIGATOR,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminSocialCareNavigator.update(data);
        dispatch({
            type: UPDATE_ADMIN_SOCIAL_CARE_NAVIGATOR,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminSocialCareNavigator.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_SOCIAL_CARE_NAVIGATOR,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminSocialCareNavigator.trash(data);
        dispatch({
            type: DELETE_ADMIN_SOCIAL_CARE_NAVIGATOR,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};